class Info {
	constructor(config) {
		this.config = Object.assign({
			scope: '[data-info="scope"]',
			open: '[data-info="open"]',
			close: '[data-info="close"]',
			content: '[data-info="content"]',
			parent: '[data-info="parent"]',
		}, config);

		this.$scope = $(this.config.scope);

		if(this.$scope.length > 0) {
			this.init();
		}
	}

	init() {
		this.addEventListeners();
	}

	addEventListeners() {
		$(document).off('.info')
			.on('click.info', `${this.config.scope} ${this.config.close}`, this.close.bind(this))
			.on('click.info', this.close.bind(this))
			.on('click.info', `${this.config.scope} ${this.config.open}`, this.open.bind(this))
	}

	open(event) {
		let $button = $(event.currentTarget);

		setTimeout(() => {
			let $content = $button.closest(this.config.scope).find(this.config.content);
			let $parent = $button.closest(this.config.parent).css('z-index', 1);
			$content.removeClass('d-none');
		}, 50);
	}

	close(event) {
		event.stopImmediatePropagation();
		let $button = $(event.currentTarget);
		let $content = $(this.config.content);
		let $parent = $button.closest(this.config.parent).css('z-index', null);
		$content.addClass('d-none');
	}
}

export default Info;